import gql from 'graphql-tag'

import { serverTaskFields } from './fragments'

export default gql`
mutation CA_web_createAutomationTaskServer($fields: AutomationTaskServerInput!) {
	cashAssist {
		createMutation: createAutomationTaskServer(fields: $fields) {
			...autoTasksServerFields
		}
	}
}
${serverTaskFields}`
